export default {
  zoneGroup: {
    id: '',
    nameLocal: '',
    nameEng: '',
  },
  zoneGroups: [],
  processing: false,
  error: null,
  success: null,
}



